export const fetchFactureOrganismes = async () => {

    
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;


    try {
        const response = await fetch(`${apiUrl}/api/organismes`,{
            headers: { 'Authorization': `Bearer ${token}`}, // Attach the token here
        });
        if (!response.ok) {
            throw new Error('Failed to fetch organisme names');
        }
        const data = await response.json();
        return data; // Return the organism data
    } catch (error) {
        console.error('Error fetching organisme names:', error);
        throw error; // Rethrow error to handle it in the component
    }
};
